// extracted by mini-css-extract-plugin
export var header = "header-default-module--header--3NbWt";
export var headerHeadline = "header-default-module--header-headline--1YmWD";
export var headerDescription = "header-default-module--header-description--3ZEat";
export var headerHeadlineContainer = "header-default-module--header-headline-container--3KQtQ";